import Phaser from 'phaser';
import config from './Config/config';

window.game = new Phaser.Game(config);
